import { ActivityRun } from '@robocorp/robocloud-orchestrator-interface';
import { WithWorkspaceId } from '~/types/common';
import {
  ActivityRunConsoleMessage,
  ActivityRunEvent,
  ActivityRunSocketInfo,
} from '~/types/resources';
import { dashboardRunApi } from '~/utils/api';

export const getActivityRunConsoleMessages = async ({
  workspaceId,
  processId,
  processRunId,
  activityRunId,
}: {
  processId: string;
  processRunId: string;
  activityRunId: string;
} & WithWorkspaceId) =>
  dashboardRunApi.get<ActivityRunConsoleMessage[]>(
    `/workspaces/${workspaceId}/processes/${processId}/runs/${processRunId}/activityruns/${activityRunId}/consolemessages`,
  );

export const getActivityRunEvents = async ({
  workspaceId,
  processId,
  processRunId,
  activityRunId,
}: {
  processId: string;
  processRunId: string;
  activityRunId: string;
} & WithWorkspaceId) =>
  dashboardRunApi.get<ActivityRunEvent[]>(
    `/workspaces/${workspaceId}/processes/${processId}/runs/${processRunId}/activityruns/${activityRunId}/events`,
  );

export const getActivityRunArtifactsLink = async ({
  workspaceId,
  processId,
  processRunId,
  activityRunId,
}: {
  processId: string;
  processRunId: string;
  activityRunId: string;
} & WithWorkspaceId) =>
  dashboardRunApi.get(
    `/workspaces/${workspaceId}/processes/${processId}/runs/${processRunId}/activityruns/${activityRunId}/artifacts`,
    { redirect: 0 },
  );

export const getActivityRunSocketInfo = async ({
  workspaceId,
  processId,
  processRunId,
  activityRunId,
}: {
  processId: string;
  processRunId: string;
  activityRunId: string;
} & WithWorkspaceId) =>
  dashboardRunApi.get<ActivityRunSocketInfo>(
    `/workspaces/${workspaceId}/processes/${processId}/runs/${processRunId}/activityruns/${activityRunId}/livedata`,
  );

export const getActivityRunArtifactLink = async ({
  workspaceId,
  processId,
  processRunId,
  activityRunId,
  artifactId,
  artifactName,
  contentDisposition,
}: {
  processId: string;
  processRunId: string;
  activityRunId: string;
  artifactId: string;
  artifactName: string;
  contentDisposition?: 'inline' | 'attachment';
} & WithWorkspaceId) =>
  dashboardRunApi.get<string>(
    `/workspaces/${workspaceId}/processes/${processId}/runs/${processRunId}/activityruns/${activityRunId}/artifacts/${artifactId}/${artifactName}?contentDisposition=${
      contentDisposition || 'inline'
    }`,
  );

export const getActivityRunsByActivity = async ({
  workspaceId,
  processId,
  activityId,
}: { processId: string; activityId: string } & WithWorkspaceId) =>
  dashboardRunApi.get(
    `/workspaces/${workspaceId}/processes/${processId}/activities/${activityId}/runs`,
  );

export const getActivityRunsByProcessRun = async ({
  workspaceId,
  processId,
  processRunId,
}: { processId: string; processRunId: string } & WithWorkspaceId) =>
  dashboardRunApi.get<ActivityRun[]>(
    `/workspaces/${workspaceId}/processes/${processId}/runs/${processRunId}/activityruns`,
  );

export const getActivityRun = async ({
  workspaceId,
  processId,
  processRunId,
  activityRunId,
}: {
  processId: string;
  processRunId: string;
  activityRunId: string;
} & WithWorkspaceId) =>
  dashboardRunApi.get<ActivityRun>(
    `/workspaces/${workspaceId}/processes/${processId}/runs/${processRunId}/activityruns/${activityRunId}`,
  );

export const getActivityRunVideoStreamToken = async ({
  workspaceId,
  processId,
  processRunId,
  activityRunId,
}: {
  processId: string;
  processRunId: string;
  activityRunId: string;
} & WithWorkspaceId) =>
  dashboardRunApi.get(
    `/workspaces/${workspaceId}/processes/${processId}/runs/${processRunId}/activityruns/${activityRunId}/videoToken`,
  );
